/* src/app/workshop/components/assets/asset-register/asset-register.component.scss */
/*# sourceMappingURL=asset-register.component.css.map */
